import { Box, Typography } from '@mui/material';
import Breadcrumbs from 'components/breadcrumbs';
import LoadingSpinner from 'components/loading-spinner';
import Paper from 'components/paper';
import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useParams } from 'react-router-dom';
import SelectSite from 'views/bluviu-nutrition/components/select-site';
import ScenarioList from 'views/bluviu-nutrition/features/scenarios-v2/components/scenario-list';
import ScenarioListFilter from 'views/bluviu-nutrition/features/scenarios-v2/components/scenario-list-filter';
import SitesOverview from 'views/bluviu-nutrition/features/scenarios-v2/components/sites-overview';
import {
  ScenarioProvider,
  useR2ScenarioState,
} from 'views/bluviu-nutrition/features/scenarios-v2/context/r2-scenario-context';
import { R2ScenarioParams } from 'views/bluviu-nutrition/features/scenarios-v2/types/r2-scenario-params.type';
import BluViuNutritionTabsHeader from '../../../components/bluviu-nutrition-tabs-header';
import { useSelectedSite } from '../../../hooks/use-selected-site';

const ScenariosOverviewList = () => {
  const { selectedSiteId } = useSelectedSite();
  const params = useParams<R2ScenarioParams>();

  const [filters, setFilters] = useState<{ generation: string; states: string[]; searchValue: string }>({
    generation: '',
    states: [] as string[],
    searchValue: '',
  });

  const {
    r2ScenariosQuery: { isLoading },
    r2ScenarioSitesQuery: { data: sites },
  } = useR2ScenarioState();



  if (!selectedSiteId) {
    return <SitesOverview />;
  }

  if (isLoading) return <LoadingSpinner />;

  return (
    <>
      <BluViuNutritionTabsHeader
        intro={
          <Typography color="white">
            <FormattedMessage id={`general.confidential`} />
          </Typography>
        }
        utils={
          <Breadcrumbs
            crumbs={
              selectedSiteId
                ? [
                    {
                      text: sites?.find((s) => s.globalSiteId === params.globalSiteId)?.name || params.globalSiteId,
                      url: ``,
                    },
                  ]
                : undefined
            }
          />
        }
      />
      <Box display={'flex'} flexDirection={'column'} gap={4}>
        <Box display={'flex'} justifyContent={'flex-end'}>
          <SelectSite />
        </Box>
        <Paper
          transparent
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 4,
          }}>
          <ScenarioListFilter filters={filters} setFilters={setFilters} />
          <ScenarioList filters={filters} />
        </Paper>
      </Box>
    </>
  );
};

const ScenariosOverview: React.FC = () => {
  return (
    <ScenarioProvider>
      <ScenariosOverviewList />
    </ScenarioProvider>
  );
};

export default React.memo(ScenariosOverview);
